import React from 'react';
import { Button } from 'seagull';
export const AddTimeActivityButton = _ref => {
  let {
    timeActivity
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, {
    "data-testid": "time-activity-".concat(timeActivity.id, "-add")
  }, "Add");
};